import { ReactElement } from "react";
import { DateTime } from "luxon";

import { DataFileResponse } from "@/redux/files/types";
import { ChapterResponse } from "@/redux/chapters/types";

export interface ContentItemProps {
  label?: string;
  content: ReactElement | undefined;
  showDivider?: boolean;
  layout?: "horizontal" | "vertical";
}

export interface FileElementProps {
  value: DataFileResponse;
}

export interface FileGroupElementProps {
  value: DataFileResponse[];
}

export enum TextType {
  REGULAR = "REGULAR",
  RICH_TEXT = "RICH_TEXT",
}

export enum FormatType {
  LINK = "LINK",
  IMAGE = "IMAGE",
  FILE = "FILE",
}

export interface TextElementProps {
  value?: string | string[] | null;
  type: TextType;
  format?: FormatType;
  multiple?: boolean;
  lineClampNumber?: number;
}

export interface DateElementProps {
  value?: string | DateTime | null;
  format?: string;
}

export interface DateRangeElementProps {
  value?: string[] | null;
  format?: string;
}

export interface DateRangeProcessedData {
  startDate: DateTime | null;
  endDate: DateTime | null;
}

export interface Tag {
  label: string;
  link?: string;
}

export interface TagsElementProps {
  value?: Tag[] | null;
}

export interface CheckboxElementProps {
  label: string;
  value: boolean;
}

export interface SliderDropdownValue {
  label: string;
  scaleLabel: string;
}

export interface SliderDropdownElementProps {
  value: SliderDropdownValue[];
}

export interface Option {
  label: string;
  value: number;
}

export interface SliderElementProps {
  value: number;
  options: Option[];
}

export interface ChapterElementProps {
  value: ChapterResponse;
}

export interface ChapterGroupElementProps {
  value: ChapterResponse[];
}
